import { AngularEditorConfig } from '@kolkov/angular-editor';

const textEditorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: '',
    showToolbar: true,
    toolbarHiddenButtons: [
        [
            'heading',
            'fontName',
            'justifyLeft',
            'justifyCenter',
            'justifyRight',
            'justifyFull'
        ],
        [
            //'fontSize',
            'textColor',
            'backgroundColor',
            'customClasses',
            'link',
            'unlink',
            'insertVideo',
            'insertHorizontalRule',
            'removeFormat',
            'toggleEditorMode'
        ]
    ]
};
const textTitleEditorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '3rem',
    minHeight: '3rem',
    placeholder: 'Enter title here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: '',
    sanitize: true,
    showToolbar: true,
    toolbarHiddenButtons: [
        [
            'heading',
            'fontName',
            'justifyLeft',
            'justifyCenter',
            'justifyRight',
            'justifyFull',
            'indent',
            'outdent',
            'insertUnorderedList',
            'insertOrderedList'
        ],
        [
            'fontSize',
            'backgroundColor',
            'customClasses',
            'link',
            'unlink',
            'insertImage',
            'insertVideo',
            'insertHorizontalRule',
            'removeFormat',
            'toggleEditorMode'
        ]
    ]
};
export { textEditorConfig, textTitleEditorConfig };
